import initBootstrap from './modules/bootstrap';
import menuMain from './modules/menu-main';
import menuAcademy from './modules/menu-academy';
import scroll from './modules/scroll';
import masonry from './modules/masonry';
import gallery from './modules/gallery';
import toc from './modules/toc';
import highlights from './modules/highlights';
import map from './modules/map';
import newsletter from './modules/newsletter';
import customSelect from './modules/custom-select';
import circleProgress from './modules/circle-progress';
import popup from './modules/popup';
import rgpd from './modules/rgpd';
import timeline from './modules/timeline';

const loadBootstrap = (context) => {
  initBootstrap({
    tooltip: false,
    popover: true,
    toasts: false,
  }, context);
};

const loadMainMenu = (context) => {
  new menuMain(context);
};

const loadAcademyMenu = (context) => {
  new menuAcademy(context);
};

const loadScroll = (context) => {
  new scroll(context);
};

const loadMasonry = (context) => {
  new masonry(context);
};

const loadGallery = (context) => {
  new gallery(context);
};

const loadToc = (context) => {
  new toc(context);
};

const loadHighlights = (context) => {
  new highlights(context);
};

const loadMap = (context) => {
  new map(context);
};

const loadNewsletter = (context) => {
  new newsletter(context);
};

const loadCustomSelect = (context) => {
  new customSelect(context);
};

const loadCircleProgress = (context) => {
  new circleProgress(context);
};

const loadPopup = (context) => {
  new popup(context);
};

const loadRgpd = (context) => {
  new rgpd(context);
};

const loadTimeline = (context) => {
  new timeline(context);
};

/**
 * Load all modules
 */
 function loadAll(context) {
  loadScroll(context);
  loadBootstrap(context);
  loadMainMenu(context);
  loadAcademyMenu(context);
  loadMasonry(context);
  loadGallery(context);
  loadToc(context);
  loadHighlights(context);
  loadMap(context);
  loadNewsletter(context);
  loadCustomSelect(context);
  loadCircleProgress(context);
  loadPopup(context);
  loadRgpd(context);
  loadTimeline(context);
}

/**
 * If we are on Drupal, use behaviors. Or, use DomContentLoaded event
 */
if (window.Drupal) {
  Drupal.behaviors.faix = {
    attach: function (context, settings) {
      loadAll(context);
    }
  };
} else {
  document.addEventListener("DOMContentLoaded", () => {
    loadAll(document);
  });
}